import { ProFormaModelIds } from "constants/proForma";

export const SUPPORTED_EXECUTIVE_SUMMARY_EXPORT_MODELS = [
    ProFormaModelIds.APARTMENT,
    ProFormaModelIds.INDUSTRIAL,
    ProFormaModelIds.RETAIL,
    ProFormaModelIds.OFFICE,
    ProFormaModelIds.APARTMENT_WITH_RETAIL,
    ProFormaModelIds.DATA_CENTER,
    ProFormaModelIds.STUDENT_HOUSING,
];